import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c50b87fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-group" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "card-panel-text" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "card-panel-num"
}
const _hoisted_6 = {
  key: 1,
  class: "card-panel-num"
}
const _hoisted_7 = {
  key: 2,
  class: "moneytype"
}
const _hoisted_8 = {
  key: 3,
  class: "card-yesterday"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "yesterday-title" }, "昨日", -1))
const _hoisted_10 = { class: "card-panel-num-yesterday" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, key) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "card-panel",
        key: key
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_el_skeleton, {
              key: 0,
              rows: 2,
              animated: ""
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(item.title), 1),
                (item.title === '总盈亏' || item.title === '总购买力')
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "info1-icon",
                      onClick: ($event: any) => (_ctx.showToolTip(item.title))
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ]),
              (item.isCustomer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(isNaN(item.asset) ? '--' : item.asset), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(isNaN(item.asset) ? '--' : _ctx.numFormat(Number(item.asset), 2)), 1)),
              (item.isEnable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createTextVNode(" 港币 "),
                      _createElementVNode("span", null, _toDisplayString(_ctx.numFormat(Number(item.HKD), 2)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createTextVNode(" 美元 "),
                      _createElementVNode("span", null, _toDisplayString(_ctx.numFormat(Number(item.USD), 2)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createTextVNode(" 人民币 "),
                      _createElementVNode("span", null, _toDisplayString(_ctx.numFormat(Number(item.CNY), 2)), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(isNaN(item.yesterdayData)
              ? '--'
              : item.isCustomer
              ? item.yesterdayData
              : _ctx.numFormat(Number(item.yesterdayData), 2)), 1),
                    (Number(item.limit) < 0 || item.limit === '-0.00')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.down
                        }, null, 8, _hoisted_11))
                      : (Number(item.limit) > 0 || item.limit === '0.00')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.up
                          }, null, 8, _hoisted_12))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            src: _ctx.diamond
                          }, null, 8, _hoisted_13)),
                    (item.isCustomer)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 3,
                          class: _normalizeClass(
              isNaN(item.limit) || Number(item.limit) === 0
                ? 'limit'
                : Number(item.limit) < 0
                ? 'down'
                : 'up'
            )
                        }, _toDisplayString(isNaN(item.limit) || Number(item.limit) === 0 ? '--' : item.limit), 3))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 4,
                          class: _normalizeClass(
              isNaN(item.limit) || item.limit === '--'
                ? 'limit'
                : Number(item.limit) < 0 || item.limit === '-0.00'
                ? 'down'
                : 'up'
            )
                        }, _toDisplayString(item.limit + '%'), 3))
                  ]))
            ]))
      ]))
    }), 128))
  ]))
}